import React from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { metadataCss } from '../../legacy-design-system/text'
import { DateTime } from '../vulnerabilities-grid/shared'

export interface LastAgentUpdateProps {
  readonly date: DateTime
}

export function LastAgentUpdate({ date }: LastAgentUpdateProps) {
  return (
    <FormattedDate
      value={date.toString()}
      year="numeric"
      month="2-digit"
      day="2-digit"
      hour="numeric"
      minute="numeric"
    >
      {(formattedDate) => (
        <FormattedMessage
          id="detail_applicationFlowMap_lastAgentUpdate"
          values={{
            date: formattedDate
          }}
          children={(msg) => <div className={metadataCss}>{msg}</div>}
        />
      )}
    </FormattedDate>
  )
}
